export const SET_ACTIVATED_CAMERA = 'SET_ACTIVATED_CAMERA'

const setActivatedCamera = camera => ({ type: SET_ACTIVATED_CAMERA, camera })

const activatedCameraActions = { setActivatedCamera }

export default activatedCameraActions
